import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-sidebar-user-profile',
  standalone: true,
  imports: [CommonModule, MatListModule],
  templateUrl: './sidebar-user-profile.component.html',
  styleUrls: ['./sidebar-user-profile.component.scss'],
})
export class SidebarUserProfileComponent {
  @Input() userData: { name: string; photoLink: string } = {
    name: '',
    photoLink: '',
  };
  @Input() showName = true;

  getInitials(): string {
    return this.userData.name
      ? this.userData.name
          .split(' ')
          .map(word => word[0])
          .join('')
          .toUpperCase()
      : '';
  }
}
